import { useState } from 'react';
import _ from 'lodash';
import { Flex, Button, Box, Icon, Text, TextField } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';
import { LABELS } from '@gorilla/widgets-shared/src/constants';
import { MoveArrowRight, Translation, CloseSmall } from '@vibe/icons';

type LabelsModalProps = {
  show: boolean;
  customLabels: Record<string, string>;
  onClose: (newCustomLabels?: Record<string, string>) => void;
};

export function LabelsModal({ show, onClose, customLabels }: LabelsModalProps) {
  const [customLabelsDraft, setCustomLabelsDraft] = useState<Record<string, string>>(() => _.cloneDeep(customLabels));

  return (
    <AppModal
      contentSpacing={false}
      alertDialog={true}
      data-testid="labelsModal"
      width="default"
      show={show}
      onClose={() => {
        onClose();
      }}
    >
      <AppModalContent>
        <Box marginBottom="small">
          <Flex direction="row" align="center" gap={8} style={{ marginBottom: '20px' }}>
            <Icon icon={Translation} size={24} />
            <Heading type="h3" weight="bold" align="start">
              Text labels
            </Heading>
          </Flex>
          <div
            style={{
              overflowY: 'auto',
              padding: '8px 16px 16px 16px',
              maxHeight: 'calc(100vh - 300px)',
              border: '1px solid #E0E0E0',
              borderRadius: '4px',
            }}
          >
            <Flex gap={8} direction="column" align="start">
              <Flex gap={10} direction="row" align="center" style={{ width: '100%' }}>
                <Text type="text2" weight="medium" style={{ flex: 1 }}>
                  Default labels
                </Text>
                <div>
                  <Icon icon={MoveArrowRight} size={18} style={{ transform: 'translate3d(0,3px,0)', opacity: 0 }} />
                </div>
                <Text type="text2" weight="medium" style={{ flex: 1 }}>
                  Custom labels
                </Text>
              </Flex>

              {LABELS.map((label) => (
                <div key={label.id} style={{ width: '100%' }}>
                  <Flex gap={10} direction="row" align="center">
                    <TextField size="small" value={label.label} disabled />
                    <div>
                      <Icon icon={MoveArrowRight} size={18} style={{ transform: 'translate3d(0,3px,0)' }} />
                    </div>
                    <TextField
                      size="small"
                      value={customLabelsDraft[label.id] || ''}
                      onChange={(newVal) => {
                        setCustomLabelsDraft((prev) => {
                          if (newVal) {
                            return {
                              ...prev,
                              [label.id]: newVal,
                            };
                          }

                          // remove the label if empty
                          const { [label.id]: _, ...rest } = prev;

                          return rest;
                        });
                      }}
                      secondaryIconName={CloseSmall}
                      clearOnIconClick={true}
                    />
                  </Flex>
                </div>
              ))}
            </Flex>
          </div>
          <Flex gap={12} justify={'end' as any} style={{ marginTop: '24px' }}>
            <Box marginEnd="auto">
              <Text type="text2">Change or translate labels displayed in the widget.</Text>
            </Box>
            <Button
              kind="secondary"
              size="medium"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button
              kind="primary"
              size="medium"
              onClick={() => {
                onClose(customLabelsDraft);
              }}
            >
              Confirm
            </Button>
          </Flex>
        </Box>
      </AppModalContent>
    </AppModal>
  );
}
